import { Button } from 'reactstrap';
import styled from 'styled-components';
import {
  asCurrencyFromCents,
  asQuantityWithUnit,
} from '../../utils/formatters';
import { featureFlags } from '../../utils/featureFlags';

const LineItem = styled.div`
  padding: 0.5rem 0;
  border-bottom: 1px solid #ddd;
`;

const TotalPrice = ({ seats, stripePrice, onEditPlan }) => {
  const total = stripePrice.unitAmount * seats;

  return (
    <div className="mb-4">
      <h2>Plan Total</h2>
      {onEditPlan && (
        <Button
          color="link"
          onClick={onEditPlan}
          size="xs"
          className="font-tiny p-0"
        >
          Edit plan
        </Button>
      )}
      <LineItem>
        <div className="d-flex align-items-center justify-content-between">
          <div>{asQuantityWithUnit('seats', 'seat')(seats)}</div>
          <div>
            {featureFlags.FREE_TRIAL_LENGTH > 0 &&
              `${featureFlags.FREE_TRIAL_LENGTH} days free then `}
            {asCurrencyFromCents(total)} per{' '}
            {stripePrice.lookupKey === 'pro_monthly' ? 'month' : 'year'}
          </div>
        </div>
      </LineItem>
    </div>
  );
};

export default TotalPrice;
